export default "__VITE_ASSET__C1QhBH0g__"